function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from "react";
import { Dialog } from "@blueprintjs/core";
import { connect } from "react-redux";
import { lifecycle, compose } from "recompose";
import { camelCase } from "lodash";
import { nanoid } from "nanoid";
import ResizableDraggableDialog from "../../ResizableDraggableDialog";
/**
 * usage:
 * in container:
 * compose(
 *   withDialog({ title: "Select Aliquot(s) From", other bp dialog props here  })
 * )
 *
 *
 * in react component
 * import MyDialogEnhancedComponent from "./MyDialogEnhancedComponent"
 *
 * render() {
 *  return <div>
 *    <MyDialogEnhancedComponent
 *      dialogProps={} //bp dialog overrides can go here
 *      target={<button>Open Dialog</button> } //target can also be passed as a child component
 *      myRandomProp={'yuppp'} //pass any other props like normal to the component
 *
 *    />
 *  </div>
 * }
 */
//  or programatically:
// const ProgramaticDialog = withDialog({
//   dialogName: "programaticDialog", //giving it a unique dialogName means you can
//   title: "Programatic Dialog Demo"
// })(DialogInner);
//
// add the no target dialog somewhere on the page
// <ProgramaticDialog></ProgramaticDialog> //this just renders without any target
//
// somewhere else on the page:
// <Button>Click To Open Dialog</Button>

export default function withDialog(topLevelDialogProps) {
  function dialogHoc(WrappedComponent) {
    return /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(DialogWrapper, _React$Component);

      function DialogWrapper() {
        return _React$Component.apply(this, arguments) || this;
      }

      var _proto = DialogWrapper.prototype;

      _proto.componentWillUnmount = function componentWillUnmount() {
        var _this$props = this.props,
            dispatch = _this$props.dispatch,
            dialogName = _this$props.dialogName,
            uniqueName = _this$props.uniqueName;

        if (dialogName) {
          dispatch({
            type: "TG_UNREGISTER_MODAL",
            name: dialogName,
            uniqueName: uniqueName
          });
        }
      };

      _proto.render = function render() {
        var _React$cloneElement;

        var _this$props2 = this.props,
            target = _this$props2.target,
            noTarget = _this$props2.noTarget,
            isDialogOpen = _this$props2.isDialogOpen,
            showModal = _this$props2.showModal,
            dialogName = _this$props2.dialogName,
            onClickRename = _this$props2.onClickRename,
            hideModal = _this$props2.hideModal,
            _this$props2$fetchPol = _this$props2.fetchPolicy,
            fetchPolicy = _this$props2$fetchPol === void 0 ? "network-only" : _this$props2$fetchPol,
            children = _this$props2.children,
            onCloseHook = _this$props2.onCloseHook,
            dialogProps = _this$props2.dialogProps,
            title = _this$props2.title,
            isDraggable = _this$props2.isDraggable,
            alreadyRendering = _this$props2.alreadyRendering,
            rest = _objectWithoutPropertiesLoose(_this$props2, ["target", "noTarget", "isDialogOpen", "showModal", "dialogName", "onClickRename", "hideModal", "fetchPolicy", "children", "onCloseHook", "dialogProps", "title", "isDraggable", "alreadyRendering"]);

        var extraDialogProps = _extends({}, topLevelDialogProps, dialogProps);

        var _onCloseHook = onCloseHook || extraDialogProps.onCloseHook;

        var _this$props$extraDial = _extends({}, this.props, extraDialogProps),
            noButtonClickPropagate = _this$props$extraDial.noButtonClickPropagate;

        var isOpen = isDialogOpen || extraDialogProps.isOpen;
        var targetEl = target || children; // if (!targetEl && !dialogName)
        //   throw new Error(
        //     "withDialog error: Please provide a target or child element to the withDialog() enhanced component. If you really don't want a target, please pass a 'noTarget=true' prop"
        //   );

        var DialogToUse = isDraggable || extraDialogProps.isDraggable ? ResizableDraggableDialog : Dialog;
        return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/React.createElement(DialogToUse, _extends({
          onClose: function onClose() {
            hideModal();
            _onCloseHook && _onCloseHook();
          },
          className: dialogName || camelCase(),
          title: title,
          isOpen: isOpen,
          canEscapeKeyClose: false,
          canOutsideClickClose: false
        }, extraDialogProps), /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, rest, {
          fetchPolicy: fetchPolicy,
          ssr: false,
          hideModal: hideModal
        }))), targetEl && React.cloneElement(targetEl, (_React$cloneElement = {}, _React$cloneElement[onClickRename || "onClick"] = function (e) {
          showModal();

          if (noButtonClickPropagate) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, _React$cloneElement)));
      };

      return DialogWrapper;
    }(React.Component);
  }

  return compose(connect(function (_ref) {
    var tg_modalState = _ref.tg_modalState;
    return _extends({}, topLevelDialogProps, {
      tg_modalState: tg_modalState
    });
  }), lifecycle({
    componentWillMount: function componentWillMount() {
      var _this$props3 = this.props,
          dispatch = _this$props3.dispatch,
          dialogName = _this$props3.dialogName;
      var uniqueName = nanoid();
      var nameToUse = dialogName || uniqueName;
      this.setState({
        nameToUse: nameToUse,
        uniqueName: uniqueName
      });

      if (dialogName) {
        dispatch({
          type: "TG_REGISTER_MODAL",
          name: dialogName,
          uniqueName: uniqueName
        });
      }
    }
  }), connect(function (_ref2, _ref3) {
    var tg_modalState = _ref2.tg_modalState;
    var nameToUse = _ref3.nameToUse,
        uniqueName = _ref3.uniqueName;
    var dialogState = tg_modalState[nameToUse] || {};

    var open = dialogState.open,
        __registeredAs = dialogState.__registeredAs,
        rest = _objectWithoutPropertiesLoose(dialogState, ["open", "__registeredAs"]);

    var newProps = _extends({}, rest, {
      isDialogOpen: open && (__registeredAs ? Object.keys(__registeredAs)[Object.keys(__registeredAs).length - 1] === uniqueName : true)
    });

    return newProps;
  }, function (dispatch, _ref4) {
    var nameToUse = _ref4.nameToUse,
        hideModal = _ref4.hideModal,
        showModal = _ref4.showModal;
    return {
      showModal: showModal || function () {
        dispatch({
          type: "TG_SHOW_MODAL",
          name: nameToUse
        });
      },
      hideModal: hideModal || function () {
        dispatch({
          type: "TG_HIDE_MODAL",
          name: nameToUse
        });
      }
    };
  }), dialogHoc);
}